import { useRouter } from 'next/router'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Link } from '~/components/Link'
import { PLAY_STORE_URL } from '~/shared/constants/appStoreUrl.const'

export default function DownloadAppBadge({
  width = 240,
  onClick,
}: {
  width?: number
  onClick?: () => void
}): React.ReactElement {
  const { locale: language } = useRouter()
  const androidSrcKey = `google/google-play-badge-${language}.png`
  const aspectRatio = 640 / 189
  const height = Math.round(width / aspectRatio)

  return (
    <Link className="md:hover:scale-110 duration-300" onClick={onClick} to={PLAY_STORE_URL}>
      <ResponsiveImage fit="contain" height={height} srcKey={androidSrcKey} width={width} />
    </Link>
  )
}
